import React from 'react';
import { TextBlock } from 'neon-design-system';
import { Children } from '../../../shared/types';

const CardNoContentHeading = ({ children }: Children) => {

	return (
		<TextBlock styleName="body">{children}</TextBlock>
	);
}

export default CardNoContentHeading;
